export default "__VITE_PUBLIC_ASSET__645d4a89__"